import { selector } from "recoil";
import {
  countriesState,
  optionsForCompanySettingState,
  instructionsState,
  currentInstructionState,
  optionsForReviewCycleState
} from "./atom";
import { get as _get, orderBy } from "lodash";
import { metaDataDetails } from "../LoggedInUserDetail/selector";

export const setCountries = selector({
  key: "setCountries",
  set: ({ set }, countriesList) => {
    set(
      countriesState,
      orderBy(countriesList?.listMetaCountrys?.items || [], "name")
    );
  }
});

export const setOptionsForCompanySetting = selector({
  key: "setOptionsForCompanySetting",
  set: ({ set }, optionsForCompanySetting) => {
    set(
      optionsForCompanySettingState,
      optionsForCompanySetting?.listMetaData?.items || []
    );
  }
});

export const setOptionsForReviewCycle = selector({
  key: "setOptionsForReviewCycle",
  set: ({ set }, optionsForReviewCycle) => {
    set(
      optionsForReviewCycleState,
      optionsForReviewCycle?.listMetaData?.items || []
    );
  }
});

export const getCountries = selector({
  key: "getCountries",
  get: ({ get }) => {
    return get(countriesState);
  }
});

export const getOptionsForCompanySetting = selector({
  key: "getOptionsForCompanySetting",
  get: ({ get }) => {
    return get(optionsForCompanySettingState);
  }
});

export const getOptionsForReviewCycle = selector({
  key: "optionsForReviewCycle",
  get: ({ get }) => {
    return get(optionsForReviewCycleState);
  }
});

export const setInstructions = selector({
  key: "setInstructions",
  set: ({ get, set }) => {
    const { instructions } = get(metaDataDetails);
    let instructionSet = {};
    if (instructions && instructions.length) {
      instructions.forEach(res => {
        instructionSet = {
          ...instructionSet,
          [res.name.replace(/\-/g, "_")]:
            JSON.parse(res?.value || {}) || {}
        };
      });
    }
    set(instructionsState, instructionSet);
  }
});

export const instructionField = selector({
  key: "getInstructionField",
  get: ({ get }) => {
    let path = get(currentInstructionState);
    let instructions = get(instructionsState);
    return _get(instructions, path);
  },
  set: ({ set }, instructionFieldPath) => {
    set(currentInstructionState, instructionFieldPath);
  }
});
